import { LEADERBOARDS_TARGETS } from '../../constants'

const addTreesField = ({ target, totalLead, monthlyLead, me }) => {

    let leaderboard = [] // = [user, ...]
    let meExt = null

    switch (target) {
    case LEADERBOARDS_TARGETS.TREE_TOTAL:
        leaderboard = [...totalLead].map((user) => ({ ...user, trees: user.treesPlantedTotal }))
        meExt = me != null ? { ...me, trees: me.treesPlantedTotal } : null
        break
    case LEADERBOARDS_TARGETS.TREE_MONTHLY:
        leaderboard = [...monthlyLead].map((user) => ({ ...user, trees: user.treesPlantedMonthly }))
        meExt = me != null ? { ...me, trees: me.treesPlantedMonthly } : null
        break
    default:
        break
    }

    return [leaderboard, meExt]
}

export default addTreesField
